import React from 'react';
import { useTranslation } from 'react-i18next';

import { FAQ_BASE_PATH } from '../../../../../config/constants';
import GenericCard from '../../../../GenericCard';
import type { SearchAllContentHit } from '../../../types';

import illustrationFaq from '../../../../../assets/images/illustrations/secondary/veelgesteldevragen.svg';
import hitTagMapper from '../../../helpers/hitTagMapper';

interface Props {
  hit: SearchAllContentHit;
  className: string;
}

const SearchAllContentResultsFaqHit: React.FC<Props> = (props) => {
  const { hit, className } = props;

  const { t } = useTranslation();

  return (
    <GenericCard
      className={className}
      title={hit.page_title[0]}
      tags={hitTagMapper([t('content_types.faq')], 'article-type')}
      subtitle={hit.body?.[0]}
      // All the FAQs are on the FAQ page. Each FAQ has a unique id attached.
      // We can use this to navigate to the FAQ page and open the FAQ accordion
      // that belongs to the id.
      link={`${FAQ_BASE_PATH}#${hit.uuid[0]}`}
      image={illustrationFaq}
    />
  );
};

export default SearchAllContentResultsFaqHit;
